<template>
  <div class="rules">
    <div class="title">活动规则</div>
    <div class="content">
      <div class="item" v-for="item in list" :key="item.id">
        <div class="icon">{{ item.id }}</div>
        <div class="text">
          <span>{{ item.title }}</span>
          <span>{{ item.content }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //             list: [
      //                 {
      //                     id: 1,
      //                     title: "消费券发放时间：",
      //                     content: `消费券每7天滚动投放（每轮发放时间分别为5月20日、5月27日、6月3日、6月10日、6月17日、6月24日，每天上午10点），1个ID每次可领取1张消费券，有效期为7天。
      // 消费券用完，活动提前结束。`,
      //                 },
      //                 {
      //                     id: 2,
      //                     title: "消费券领取规则：",
      //                     content:
      //                         "每人每轮限领1张汽车消费券。如成功申领2次汽车消费券但均未使用，视为自动放弃，无法再参与本次活动。",
      //                 },
      //                 {
      //                     id: 3,
      //                     title: "消费券使用规则：",
      //                     content: `
      //                     消费券仅限购买个人非营运车辆，消费者通过南太湖号APP领取汽车消费券，领券成功以后在卡包里展示。
      // 消费券按照裸车开票成交价使用，每辆汽车仅限使用1张消费券（发票信息与消费券使用人信息须保持一致）。到店消费时，点击消费券上的“去使用”按钮，即可享受相应优惠。 `,
      //                 },
      //             ],
      list: [
        {
          id: 1,
          title: "",
          content: `用户在指定4S店购车时，完成实名认证方可领用一张券；`,
        },
        {
          id: 2,
          title: "",
          content: "一个实名注册限领一张汽车消费券；",
        },
        {
          id: 3,
          title: "",
          content: `一辆车限用一张消费券（满5万可用1000元消费券/满10万可用3000元消费券/满20万可用6000元消费券/满30万可用8000元消费券）；`,
        },
        {
          id: 4,
          title: "",
          content: `所领取消费券只限当日使用，次日作废；`,
        },
        {
          id: 5,
          title: "",
          content: `使用消费券核销购车，只需支付扣除消费券金额之后的尾款；`,
        },
        {
          id: 6,
          title: "",
          content: `领券人、购车人以及购车发票信息必须一致；`,
        },
        {
          id: 7,
          title: "",
          content: `重复领取两次消费券但均未使用的用户，将无法获得再次领券资格；`,
        },
        {
          id: 8,
          title: "",
          content: `满5万/10万/20万/30万均指汽车裸车开票价格；`,
        },
        {
          id: 9,
          title: "",
          content: `用券所购车辆为个人所有，不得用于企业或单位购车；`,
        },
        {
          id: 10,
          title: "",
          content: `通过指定4S店扫码获取的汽车消费券只能被该4S店核销人员进行核销。`,
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.rules {
  background: #0f6ad3;

  padding: 10px;
  margin-top: -40px;
  // position: relative;

  .title {
    font-size: 18px;
    color: #fff;
    text-align: center;
    padding: 10px;
    z-index: 1 !important;
    position: relative;
  }

  .content {
    background: #fff;
    border-radius: 10px;
    // margin: 20px;
    padding: 10px;
    .item {
      display: flex;
      margin-bottom: 10px;

      .icon {
        width: 26px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        font-size: 12px;
        color: #fff;
        border-radius: 50%;
        background: @main;
        margin-right: 10px;
      }
      .text {
        flex: 1;
        line-height: 26px;

        span:first-child {
          font-weight: bold;
        }
      }
    }
  }
}
</style>
